import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/layouts/auth.vue").then(m => m.default || m)),
  catalog: defineAsyncComponent(() => import("/app/layouts/catalog.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/app/layouts/empty.vue").then(m => m.default || m))
}